import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-close\"><path d=\"M18.513 16 31.479 3.034A1.778 1.778 0 0 0 28.965.522l.001-.001L16 13.487 3.034.521A1.778 1.778 0 0 0 .522 3.035l-.001-.001L13.487 16 .521 28.966a1.76 1.76 0 0 0 0 2.512 1.774 1.774 0 0 0 2.512 0l12.966-12.966 12.966 12.966a1.774 1.774 0 0 0 2.512 0 1.76 1.76 0 0 0 0-2.512z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol